import styled, { css } from 'styled-components';
import { lg, xl, xs } from '@exonet/react-shared/lib/styled';
import { Row } from '@exonet/react-shared/lib/Form/styled';

export const Container = styled.div`
  padding: var(--xs-padding);
  background-color: var(--form-bg);
  border-radius: var(--border-radius);
  box-shadow: var(--form-box-shadow, var(--box-shadow));
  color: var(--text);

  ${lg(css`
    padding: var(--lg-padding);
  `)};

  ${xl(css`
    padding: var(--xl-padding);
  `)};
`;

export const MobileForm = css`
  ${Row} {
    display: flex;
    flex-flow: column;

    > div {
      margin-right: 0;
    }

    ${xs(css`
      flex-flow: row;
      gap: 10px !important;
    `)}
  }
`;

export const statusLabel = (colors) => styled.div`
  color: #ffffff;
  padding: 0px var(--xs-padding-horizontal) 2px;
  border-radius: 2px;
  background-color: ${({ status }) => colors[status]};
  text-transform: lowercase;
  font-size: var(--sm-font-size);
  max-width: fit-content;
`;

export const DataManagerContainer = styled(Container)`
  min-height: 200px;

  ${xl(css`
    padding: var(--lg-padding);
  `)};

  .shared-table {
    box-shadow: none;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-flow: column;
  margin-top: var(--xl-padding-vertical);
`;
